import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import Loading from './Loading';

export default class AsyncLoadingWrapper extends React.Component {

    state = {
        done: false,
        error: false
    }

    componentDidMount() {
        this.props.action().then((response) => {
            this.setState({ done: true })
            this.props.onComplete(response);
        })
        .catch((e) => {
            this.setState({ error: e })
            this.props.onCatch(e);
        });
    }

    render() {
        if (this.state.done) {
            return this.props.children;
        }
        else if(this.state.error) {
            if(this.props.renderError)
                return this.props.renderError(this.state.error);
            else
                return (<div><h1>Error</h1></div>) //TODO: Replace with better error message
        }
        else{
            if(this.props.renderLoading)
                return this.props.renderLoading();
            else
                return (<Loading />);
        }
    }
}